import React from "react";
import { Party } from './widgets/Party';
import { InteractiveMap } from './InteractiveMap/InteractiveMap';
import { ScheduleColumn, ScheduleDisplayProps, ScheduleProps } from './Schedule/Schedule';

import { CreateStateManager, StateManager } from './widgets/PartyState';
import { DataDisplayPanel } from './InteractiveMap/DataDisplayPanel';
import { StateManagerContext } from './widgets/StateManagerContext';
import { SignUpForm } from "./widgets/SignUpForm";
import { CreateEmptyUIConfig, UIConfig, UIConfigContext } from "./widgets/UIConfigContext";
import { googleLogout } from "@react-oauth/google";
import { ArtStyle } from "./Shared/Creative/ArtStyle";
import { MarketingPanel, MarketingPanelProps } from "./widgets/MarketingPanel";




interface GoogleDetails {
    email: string,
    name: string
}

const googleClientId = '835121614665-kuh77kbndgiuho87r66biiq022malkkt.apps.googleusercontent.com';



export type HomePageProps = {
    partyId?: string,
    offset?: string,
    userId?: string,
}

export const HomePage = ({ partyId, offset, userId }: HomePageProps): JSX.Element => {
    const offsetValue = offset === undefined ? undefined : parseInt(offset);
    const stateManagerInit = React.useRef<boolean>(false);
    const stateInitCalled = React.useRef<boolean>(false);

    const stateManager = React.useRef<StateManager | null>(null);

    if (!stateManagerInit.current) {
        stateManagerInit.current = true;
        const sm = CreateStateManager(undefined, partyId, offsetValue, userId);
        console.log('Create State Manager in Homepage =' + sm.getObjId());
        stateManager.current = sm;

    }

    const stateLoadedRef = React.useRef<boolean>(false);
    const [stateLoaded, setStateLoaded] = React.useState<boolean>(false);

    const stateManagerLoadedHandler = () => {
        stateLoadedRef.current = true;
        setStateLoaded(true);
        console.log('setLoaded true for stateManager id=' + (stateManager.current !== null ? stateManager.current?.getObjId() : 'null'));
    }
    //const [selectedRegion, setSelectedRegion] = React.useState<string>('US');
    const [showSignUpForm, setShowSignUpForm] = React.useState<boolean>(false);

    const [viewportWidth, viewportHeight] = [window.innerWidth, window.innerHeight];
    let [partyWidth, partyHeight] = [viewportWidth, viewportHeight];
    let displayParty = true;
    let displayInfo = false;
    var appWidth = viewportWidth + "px";
    var partyMarginTop = "0px";
    if (viewportWidth > viewportHeight) {
        displayInfo = true;
        appWidth = "1410px";
        partyHeight = viewportHeight - 20;
        partyMarginTop = "20px";
        if (viewportHeight < 800) {
            displayParty = false;
        }
        else
            partyWidth = 500; //partyHeight / 1920 * 1080;
    }
    const uiConfig = React.useRef<UIConfig>((() => {
        const uc = CreateEmptyUIConfig();
        uc.width = partyWidth;
        uc.height = partyHeight;
        const func = async () => {
            const uri = '/images/artstyles/directory.json';
            const response = await fetch(uri, {
                method: "GET",
                headers: { "content-type": "application/json" }
            });
            const json = await response.json();
            const artStyles = json as ArtStyle[];
            uc.artStyles = artStyles;
        }
        func();
        return uc;
    })());

    const showSignUpHandler = () => {
        setShowSignUpForm(true);
        const panel = document.getElementById("signUpForm");
        if (panel !== null) {
            panel.style.top = '0px';
        }
        else {
            setTimeout(() => {
                const panel = document.getElementById("signUpForm");
                if (panel !== null) {
                    panel.style.top = '0px';
                }
            }, 500);

        }
    }

    const closeSignUpHandler = () => {
        const panel = document.getElementById("signUpForm");
        if (panel !== null) {
            panel.style.top = partyHeight + 'px';
        }
        window.setTimeout(() => { setShowSignUpForm(false) }, 1000);
    }

    if ((!stateLoadedRef.current) && (stateManager.current !== null) && (!stateInitCalled.current)) {
        stateInitCalled.current = true;
        stateManager.current.init(stateManagerLoadedHandler, showSignUpHandler);
    }




    const displaySchedule: ScheduleDisplayProps = {
        boxWidth: 170,
        imageHeight: 97,
        panelHeight: 75,
        gap: 14,
        slots: 5,
        style: {
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: "20px"
        }
    }



    const schedule: ScheduleProps = {
        display: displaySchedule

    }



    //const moreDataRequest = (region: string) => {
     //   setSelectedRegion(region);
   // }

    const mprops : MarketingPanelProps = {
        height : partyHeight + 20,
        width : 691
    }




    console.log('rendering for stateManager id=' + (stateManager.current !== null ? stateManager.current.getObjId() : 'null') + ' stateLoaded = ' + stateLoaded);
    if (stateLoaded && stateManager.current !== null)
        return <StateManagerContext.Provider value={stateManager.current} >

            <UIConfigContext.Provider value={uiConfig.current}>

                <div className="App">
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: appWidth,
                        maxWidth: appWidth,
                        minWidth: appWidth,

                        background: "linear-gradient( rgba(60, 10, 60, 0.85), rgba(60, 60, 0, 0.85) ), url('/images/fanbox-background.png')",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "100%",
                        margin: "auto",

                    }}>
                        {displayInfo && <div style={{ overflow: 'clip', maxHeight: (partyHeight + 20) + 'px' }}>
                            <ScheduleColumn {...schedule} /></div>}
                        {(displayParty) && <div style={{ width: partyWidth + 'px', height: partyHeight + 'px', marginTop: partyMarginTop, borderRadius: "25px", overflow: 'clip', position: 'relative' }}><Party />

                            <div id='signUpForm' style={{ opacity: 1.0, transition: 'top 1s', transitionTimingFunction: 'ease-in-out', position: 'absolute', top: partyHeight + 'px' }}>
                                {showSignUpForm && <SignUpForm width={partyWidth} height={partyHeight} background='#303030' fontSize={16} complete={closeSignUpHandler} />}
                            </div>
                        </div>}
                        {displayInfo && <MarketingPanel {...mprops}/>
                            
                        }
                    </div>
                </div>
            </UIConfigContext.Provider>

        </StateManagerContext.Provider>;
    else return <div style={{
        minWidth: viewportWidth + 'px',
        width: viewportWidth + 'px',
        maxWidth: viewportWidth + 'px',
        minHeight: viewportHeight + 'px',
        height: viewportHeight + 'px',
        maxHeight: viewportHeight + 'px',
        backgroundColor: 'black',
        backgroundImage: 'url("/images/spinner.gif")',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto'
    }}> The App is loading</div>;


}